import { render } from "./list-supplier.vue?vue&type=template&id=27a1be63"
import script from "./list-supplier.vue?vue&type=script&lang=js"
export * from "./list-supplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__